/* DSL Re-engagement — markeer last-visit timestamp; push triggert via SW als >14 dagen inactief */
(function(){
  try { localStorage.setItem("dsl_last_visit", String(Date.now())); } catch(e){}
})();